import React from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { CalendarMonth, RocketLaunch } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

/**
 * Post interactive-demo logout: offer a call, or send them to Get Started.
 */
const DemoExitPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <SEO
        title="Still Have Questions? | LawnHub"
        description="Finished the LawnHub interactive demo? Schedule a call or get started with your account."
      />
      <Paper elevation={3} sx={{ p: { xs: 3, sm: 4 } }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 800, mb: 1.5 }}>
          Still have questions?
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Thanks for trying the interactive demo. Want a quick call or virtual meet with us, or are
          you ready to get started on your own?
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="contained"
            size="large"
            startIcon={<CalendarMonth />}
            onClick={() => navigate('/demo/schedule-call')}
            sx={{
              py: 1.5,
              fontWeight: 800,
              textTransform: 'none',
              fontSize: '1.05rem',
            }}
          >
            Yes — schedule a call / virtual meet
          </Button>
          <Button
            variant="outlined"
            size="large"
            startIcon={<RocketLaunch />}
            onClick={() => navigate('/get-started')}
            sx={{
              py: 1.5,
              fontWeight: 700,
              textTransform: 'none',
              fontSize: '1.05rem',
            }}
          >
            No more questions — create my free account
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default DemoExitPage;
